import { FC } from 'react';
import { Segmented as AntdSegmented, SegmentedProps as AntdSegmentedProps } from 'antd';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

type SegmentedProps = Omit<AntdSegmentedProps, 'size'> & {
  size?: 'sm' | 'md';
};

export const Segmented: FC<SegmentedProps> = ({ options, onChange, size = 'sm', ...props }) => (
  // @ts-ignore
  <StyledSegmented
    className={cn({ small: size === 'sm', medium: size === 'md' })}
    options={options}
    onChange={onChange}
    {...props}
  />
);

const StyledSegmented = styled(AntdSegmented)`
  &.ant-segmented {
    padding: 2px;
    border-radius: 8px;
    background: ${COLORS.systemLight300};
  }

  &.small {
    height: 32px;
  }
  &.medium {
    height: 36px;
  }
  & .ant-segmented-group {
    height: 100%;
  }
  & .ant-segmented-item.ant-segmented-item-selected {
    border-radius: 6px;
  }
  & .ant-segmented-item-label {
    height: 100%;
    min-height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
